module.exports = __webpack_public_path__ + "img/user-default.cd85a4ad.jpg";